import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../../config/supabase';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { User, MapPin, Heart } from '../../lib/lucide-proxy';

const UserProfile = () => {
  const { slug } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data, error } = await supabase
          .from('users')
          .select('*')
          .eq('slug', slug)
          .single();
          
        if (error) throw error;
        setProfile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><LoadingSpinner /></div>;
  if (!profile) return <div className="min-h-screen flex items-center justify-center">Perfil não encontrado</div>;

  return (
    <>
      <Helmet>
        <title>{profile.full_name} - Perfil Cervejeiro</title>
      </Helmet>

      <div className="min-h-screen bg-cream-300 py-12">
        <div className="max-w-3xl mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-soft overflow-hidden">
            <div className="h-32 bg-gradient-to-r from-primary-500 to-copper-500"></div>
            <div className="px-8 pb-8">
              <div className="relative -mt-16 mb-6">
                <div className="w-32 h-32 rounded-full border-4 border-white bg-gray-200 flex items-center justify-center overflow-hidden">
                  {profile.avatar_url ? (
                    <img src={profile.avatar_url} alt={profile.full_name} className="w-full h-full object-cover" />
                  ) : (
                    <User className="w-16 h-16 text-gray-400" />
                  )}
                </div>
              </div>

              <h1 className="font-display font-bold text-3xl text-dark-900 mb-2">{profile.full_name}</h1>
              
              {profile.location && (
                <div className="flex items-center text-dark-500 mb-6">
                  <MapPin className="w-4 h-4 mr-1" />
                  <span>{profile.location}</span>
                </div>
              )}

              {profile.bio && (
                <p className="text-dark-600 mb-8 max-w-xl">{profile.bio}</p>
              )}

              <div className="border-t border-gray-100 pt-8">
                <h2 className="font-bold text-lg mb-4 flex items-center">
                  <Heart className="w-5 h-5 mr-2 text-red-500" />
                  Estilos Favoritos
                </h2>
                <div className="flex gap-2 flex-wrap">
                  {/* Mocked preferences for now */}
                  <span className="px-4 py-2 bg-gray-50 rounded-full text-sm font-medium text-dark-700">IPA</span>
                  <span className="px-4 py-2 bg-gray-50 rounded-full text-sm font-medium text-dark-700">Stout</span>
                  <span className="px-4 py-2 bg-gray-50 rounded-full text-sm font-medium text-dark-700">Sour</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;